import { Modal } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";
import { WORKSPACE_ROLES_CAPABILITIES } from "../../Utils/workspaceRoleCapabilities";
import { useContext, useEffect, useRef, useState } from "react";
import AuthContext from "../../context/auth/AuthContext";

const InviteMembersModal = (props) => {
  const {
    isOpen,
    onClose,
    setMemberData,
    memberData,
    handleAddMember,
    handleRemoveMember,
    handleSubmit,
    handleGoBackToInviteCustomization,
    disableButtons,
    workspaceName,
    goToPrevStep,
    goToStepSix,
    goToStepFive,
    goToStepFour,
  } = props;
  const { _t } = useTranslator();

  const { user } = useContext(AuthContext);
  const [roleDropdown, setRoleDropdown] = useState(false);
  const roleDropdownRefs = useRef({});

  const handleInputChange = (index, field, value) => {
    setMemberData((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [field]: value,
      };
      return updated;
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const activeRef = roleDropdownRefs.current[roleDropdown];

      if (activeRef && !activeRef.contains(event.target)) {
        setRoleDropdown(-1);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [roleDropdown]);

  return (
    <Modal
      show={isOpen}
      onHide={() => {
        handleGoBackToInviteCustomization();
        goToStepFour();
        onClose();
      }}
      centered
      id="invite-member-walkthrough"
      className="newmodalui max-w-lg tailwind-base-modal wrapper-modal invite-members-modal"
    >
      <Modal.Header closeButton={false}>
        <Modal.Title>{_t("inviteMembers")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-center">
          {_t("inviteMembersTo")} <b>{workspaceName}</b> {_t("workspace")}{" "}
        </p>
        <div className="grid-input-wrapper d-flex custom-mt-6 flex-column custom-gap-3">
          {memberData.map((member, index) => (
            <div
              key={index}
              className="main-form-group form-group-wrapper grid-input position-relative"
            >
              <div
                className="form-group formGroup flex-row justify-content-between"
                style={{ width: index > 0 ? "96%" : "100%" }}
              >
                <input
                  style={{ width: "60%", marginRight: ".2778vw" }}
                  type="text"
                  value={member.email}
                  placeholder={_t("enterEmail")}
                  onChange={(e) =>
                    handleInputChange(
                      index,
                      "email",
                      e.target.value?.toLowerCase(),
                    )
                  }
                  name="email"
                  required
                />
                <div ref={(el) => (roleDropdownRefs.current[index] = el)}>
                  <div
                    className="d-flex align-items-center inputMemberTypeDropdown custom-gap-2 justify-content-between cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      setRoleDropdown(index);
                    }}
                  >
                    <div className="container-heading">
                      <div>
                        <h3>
                          {member.role
                            ? _t(`${member.role?.toLowerCase()}Member`)
                            : _t("pleaseSelect")}
                        </h3>
                      </div>
                    </div>
                    <img
                      src="/images/down-arrow-grey.svg"
                      style={{
                        rotate: roleDropdown === index ? "180deg" : "0deg",
                      }}
                    />
                  </div>

                  {roleDropdown === index && (
                    <div className="position-absolute memberTypeDropdownList memberTypeWithPara">
                      <div className="dropdown-menu-inner d-flex flex-column">
                        {WORKSPACE_ROLES_CAPABILITIES?.roleHierarchyBasedOnIndex?.map(
                          (role) => (
                            <div
                              className="dropdown-open-container position-relative cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleInputChange(index, "role", role);
                                setRoleDropdown(-1);
                              }}
                            >
                              <div className="d-flex gap-2">
                                {role?.toLowerCase() == "owner" && (
                                  <img
                                    src="/images/manage-owner-icon.svg"
                                    alt=""
                                  />
                                )}
                                <div
                                  style={{
                                    marginLeft:
                                      role?.toLowerCase() !== "owner"
                                        ? "24px"
                                        : 0,
                                  }}
                                >
                                  <h3 className="d-flex align-items-center justify-content-between flex-col">
                                    {_t(`${role?.toLowerCase()}Member`)}{" "}
                                  </h3>
                                  <p>
                                    {_t(`${role?.toLowerCase()}Description`)}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ),
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {index > 0 && (
                <img
                  src="/images/cancel-grey.svg"
                  alt="Close"
                  className="cancelIcon cursor-pointer cancelIconForm"
                  onClick={() => handleRemoveMember(index)}
                />
              )}
            </div>
          ))}
        </div>

        <button className="addMoreMemberButton" onClick={handleAddMember}>
          <img src="/images/plusIconGreen.svg" className="Plus" />
          {_t("addMoreMember")}
        </button>
      </Modal.Body>
      <div className="inviteButtonWrapper">
        <button
          type="button"
          onClick={() => {
            handleGoBackToInviteCustomization();
            goToStepFour();
          }}
          disabled={disableButtons}
          className="btnNext btnnextpre mr-2"
        >
          {_t("goBack")}
        </button>
        <button
          type="button"
          onClick={() => {
            // if (user?.tourCompleted) {
            handleSubmit();
            // } else {
            //   goToStepSix?.();
            // }
          }}
          disabled={disableButtons}
          className="btnNext basicInfoButton greenHover"
        >
          {_t("createWorkspace")}
        </button>
      </div>
    </Modal>
  );
};

export default InviteMembersModal;
